import React from "react";
import { CASE_STUDY_EVIDENCE_IMAGE } from "./caseStudyContent";

const CaseStudyEvidence = ({ className = "" }) => (
  <img
    src={CASE_STUDY_EVIDENCE_IMAGE}
    alt="Oz Exteriors calendar and qualification logs after digital brain deployment"
    className={`w-full h-auto block ${className}`}
    data-testid="case-study-evidence"
    loading="lazy"
  />
);

export default CaseStudyEvidence;
